import { render, staticRenderFns } from "./card.modalPunch.vue?vue&type=template&id=7630967c&"
import script from "./card.modalPunch.vue?vue&type=script&lang=js&"
export * from "./card.modalPunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports